/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import PropTypes from 'prop-types';

import React from 'react';
import Localized from '../../../shared/components/Localized';
import { ModalHeader } from './index';
import styled from 'styled-components';
const DismissButton = styled.button`
  width: 111px;
  height: 36px;
  border-radius: 3px;
`;
const EmailImage = styled.img.attrs({
  src: '/images/email.svg'
})`
  margin-bottom: 40px;
`;
const ModalBoxStyle = {
  borderBottomWidth: 0, 

}

export default class SubscriptionAdded extends React.Component {
  constructor(props) {
    super(props);
  }

  static propTypes = {
    closeModal: PropTypes.func,
    isOpen: PropTypes.bool,
    header: PropTypes.object,
    body: PropTypes.object
  };  
  render() {
    const { closeModal, emailAddress } = this.props;

    return (
<div>
        <ModalHeader>
          <h2 className="slds-text-heading--medium">
          Subscription Added
          </h2>
        </ModalHeader>
        <div className="slds-modal__content-footer">
          <div className="slds-m-left--large slds-m-right--medium slds-text-heading--x-small slds-modal__header" style = {ModalBoxStyle}>
            {' '}
            <div className="slds-m-right--medium ">
                Your subscription has been successfully added
            </div>
          </div>
        </div>
        <div className="slds-modal__footer slds-align--absolute-center">
          <div className="slds-x-small-buttons--horizontal modal-footer-center">
            <DismissButton
              className="slds-button slds-button--brand"
              onClick={closeModal}
            >
              <Localized
                modelName={'modal'}
                modelKey={'dismiss'}
                modelAttribute={'label'}
              />
            </DismissButton>
          </div>
        </div>
        </div>
    );
  }
}
